/* tslint:disable */
import {
  Role
} from '../index';

declare var Object: any;
export interface OpenErpUserInterface {
  "uid": number;
  "name"?: string;
  "rawPassword"?: string;
  "database": string;
  "email"?: any;
  "realm"?: string;
  "username"?: string;
  "emailVerified"?: boolean;
  "id"?: number;
  "password"?: string;
  accessTokens?: any[];
  roles?: Role[];
  roleBindings?: any[];
}

export class OpenErpUser implements OpenErpUserInterface {
  "uid": number;
  "name": string;
  "rawPassword": string;
  "database": string;
  "email": any;
  "realm": string;
  "username": string;
  "emailVerified": boolean;
  "id": number;
  "password": string;
  accessTokens: any[];
  roles: Role[];
  roleBindings: any[];
  constructor(data?: OpenErpUserInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OpenErpUser`.
   */
  public static getModelName() {
    return "OpenErpUser";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OpenErpUser for dynamic purposes.
  **/
  public static factory(data: OpenErpUserInterface): OpenErpUser{
    return new OpenErpUser(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OpenErpUser',
      plural: 'OpenErpUsers',
      path: 'OpenErpUsers',
      idName: 'id',
      properties: {
        "uid": {
          name: 'uid',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "rawPassword": {
          name: 'rawPassword',
          type: 'string'
        },
        "database": {
          name: 'database',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'any'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        roles: {
          name: 'roles',
          type: 'Role[]',
          model: 'Role',
          relationType: 'hasMany',
          modelThrough: 'RoleMapping',
          keyThrough: 'roleId',
          keyFrom: 'id',
          keyTo: 'principalId'
        },
        roleBindings: {
          name: 'roleBindings',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'principalId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/OpenErpUser.ts